export default "__VITE_ASSET__DJX4swr3__"